if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        const formData = new FormData(this.form);
        const kilnValidation = this.validateKilnInfo(formData);
        if (!kilnValidation.valid) {
          if (kilnValidation.message) {
            this.handleErrorMessage(kilnValidation.message);
          }
          return;
        }

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      validateKilnInfo(formData) {
        if (this.dataset.requiresKilnInfo !== 'true') {
          return { valid: true };
        }

        const partNumber = (formData.get('properties[Kiln Part Number (P/N)]') || '').trim();
        const serialNumber = (formData.get('properties[Kiln Serial Number (S/N)]') || '').trim();
        const acceptedWords = ['Duncan', 'duncan', 'DUNCAN'];
        let valid = true;
        let formMessage = null;

        const partInput = document.querySelector('.custom-kiln-part-number');
        const serialInput = document.querySelector('.custom-kiln-serial-number');
        const partError = partInput?.closest('.kiln-part-number')?.querySelector('.kiln_number_error');
        const serialError = serialInput?.closest('.kiln-serial-number')?.querySelector('.kiln_number_error');

        if (!partNumber) {
          valid = false;
          if (partError) {
            partError.style.display = 'inline';
            partError.innerText = 'This field cannot be empty!';
          }
        } else if (partError) {
          partError.style.display = 'none';
        }

        if (!serialNumber) {
          valid = false;
          if (serialError) {
            serialError.style.display = 'inline';
            serialError.innerText = 'This field cannot be empty!';
          }
        } else if (serialError) {
          serialError.style.display = 'none';
          if (!acceptedWords.includes(serialNumber)) {
            const numericValue = parseInt(serialNumber, 10);
            if (isNaN(numericValue) || numericValue < 250000 || numericValue > 550000) {
              valid = false;
              serialError.style.display = 'inline';
              serialError.innerText =
                'The serial number you input is invalid. Please check the dataplate on your kiln again.';
            }
          }
        }

        if (!valid) {
          formMessage =
            !partInput && !serialInput
              ? 'Part Number and Serial Number are required for this product.'
              : 'Please fill in the required Part Number and Serial Number fields.';
        }

        return { valid, message: formMessage };
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
